import { ChevronDown } from "lucide-react";

export default function CatalogEditorSection({
  children,
  defaultOpen = false,
  id,
  isOpen,
  onToggle,
  summary,
  title,
}) {
  return (
    <section
      className="catalog-editor-section"
      data-testid={`catalog-section-${id}`}
    >
      <button
        aria-expanded={isOpen}
        className="catalog-section-toggle"
        onClick={onToggle}
        type="button"
        data-testid={`catalog-section-toggle-${id}`}
      >
        <span>
          <strong>{title}</strong>
          {summary && <small>{summary}</small>}
        </span>
        <ChevronDown className={isOpen ? "is-open" : ""} size={18} />
      </button>
      {isOpen && <div className="catalog-section-body">{children}</div>}
    </section>
  );
}
